import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import '../../styles/Certificate.css';
import { signedAuthHeaders } from '../../api';
import { CERT_SEAL } from '../../catalogCovers';

function shortWallet(wallet) {
  const value = String(wallet || '');
  if (value.length < 12) {
    return value;
  }
  return value.slice(0, 6) + '…' + value.slice(-4);
}

const Certificate = () => {
  const { id } = useParams();
  const [certificate, setCertificate] = useState(null);
  const [recipient, setRecipient] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const headers = await signedAuthHeaders({ Accept: 'application/json' });
        const res = await fetch(`/api/certifications/${id}`, { headers });
        const text = await res.text();
        if (!res.ok) {
          throw new Error(res.status === 404 ? 'Certificate not found.' : `Could not load certificate (${res.status})`);
        }
        const data = text ? JSON.parse(text) : null;
        if (cancelled) {
          return;
        }
        setCertificate(data);
        const wallet = data && (data.userid || data.userId);
        let name = '';
        if (wallet) {
          try {
            const profileRes = await fetch(`/api/profile/${encodeURIComponent(wallet)}`);
            if (profileRes.ok) {
              const profile = await profileRes.json();
              name = (profile.name || profile.nickname || '').trim();
            }
          } catch {
            name = '';
          }
        }
        if (!cancelled) {
          setRecipient(name || shortWallet(wallet) || 'Wisdom learner');
          setLoading(false);
        }
      } catch (err) {
        console.error('Error fetching certificate:', err);
        if (!cancelled) {
          setCertificate(null);
          setLoading(false);
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [id]);

  if (loading) return <p>Loading...</p>;
  if (!certificate) return <p>Certificate not found.</p>;

  return (
    <div className="certificate-container">
      <div className="certificate">
        <img className="certificate-seal" src={certificate.imageurl || certificate.imageUrl || CERT_SEAL} alt="" />
        <h1>Certificate of Completion</h1>
        <p className="subtitle">This certifies that</p>
        <h2 className="username">{recipient}</h2>
        {certificate.userid ? <p className="wallet-line">{certificate.userid}</p> : null}
        <p>has successfully completed the course</p>
        <h3 className="course-title">"{certificate.coursetitle}"</h3>
        <p className="date">Issued on: {certificate.issueddate}</p>
        <div className="signature-section">
          <div className="signature">
            <p>Olga Smirnov</p>
            <span>Director, Wisdom Academy</span>
          </div>
          <div className="signature">
            <p>AI Verification</p>
            <span>Blockchain Verified</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Certificate;